export const signupStatuses = {
    PENDING: "Pending",
    APPROVED: "Approved",
    DENIED: "Denied",
    ERROR: "Error", 
    CANCELED: "Canceled",
    NEEDS_REVIEW: "Needs Review"
  }